import Axios from "axios";

const mainUrl = process.env.VUE_APP_URL;

let apiToken = null;
const initHeaders = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
refreshApiToken();

const axiosInstance = Axios.create({
  baseURL: mainUrl,
  headers: initHeaders,
});

const axiosFile = Axios.create({
  baseURL: mainUrl,
  headers: {
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
  },
});

function getPath(payload) {
  let iterations = Object.entries(payload).length;
  var pathArr = "?";
  for (let key in payload) {
    if (!--iterations) {
      pathArr += key + "=" + payload[key];
    } else {
      pathArr += key + "=" + payload[key] + "&";
    }
  }
  return pathArr;
}

function handleAuthError(_this, error = null) {
  if (apiToken === null) {
    refreshApiToken();
  }
  if (
    error !== null &&
    ((typeof error.request.status === "number" &&
      error.request.status === 403) ||
      error.request.status === 401)
  ) {
    localStorage.clear();
    _this.$router.push({ name: "Login" });
  }
}

export function GET(
  payload = [],
  url,
  _this,
  notification = true,
  load = true,
  isBlob = false
) {
  if (load) _this.$store.state.isLoading = true;

  /* Params ?page=2&smth=10 */
  var params = "";
  if (Object.entries(payload).length > 0) {
    params = getPath(payload);
  }

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url + params, {
        responseType: isBlob ? 'blob' : 'json'
      })
      .then((response) => {
        notification === true ? primaryNotification(_this) : "";
        isBlob ? resolve(response) : resolve(response.data.result)
        if (load) _this.$store.state.isLoading = false;
      })
      .catch((error) => {
        if (load) _this.$store.state.isLoading = false;
        reject(error);
        handleAuthError(_this, error);
        errorNotification(_this, error, notification);
      });
  });
}
export function RawGET(
  payload = [],
  url,
  _this,
  notification = true,
  load = true
) {
  if (load) _this.$store.state.isLoading = true;

  /* Params ?page=2&smth=10 */
  var params = "";
  if (Object.entries(payload).length > 0) {
    params = getPath(payload);
  }

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url + params)
      .then((response) => {
        notification === true ? primaryNotification(_this) : "";
        resolve(response);
        if (load) _this.$store.state.isLoading = false;
      })
      .catch((error) => {
        if (load) _this.$store.state.isLoading = false;
        reject(error);
        handleAuthError(_this);
        errorNotification(_this, error, notification);
      });
  });
}

function grepErrorNotification(error, _this) {
  let res =
    typeof error.request !== "undefined" &&
    typeof error.request.response === "string"
      ? isJson(error.request.response)
      : null;
  let message =
    res !== null && typeof res.message !== "undefined" ? res.message : null;
  let resErr =
    typeof error.response !== "undefined" &&
    typeof error.response.data !== "undefined"
      ? error.response.data
      : null;
  let messageRes =
    resErr !== null && typeof resErr.data !== "undefined" ? resErr.data : null;
  let messageRes1 =
    resErr !== null && typeof resErr.error !== "undefined"
      ? resErr.error
      : null;
  handleAuthError(_this);
  message != null
    ? errorNotification(_this, message)
    : messageRes != null
    ? errorNotification(_this, messageRes)
    : messageRes1 != null
    ? errorNotification(_this, messageRes1)
    : errorNotification(_this, error);
}

export function POST(payload, url, _this, notification = true) {
  _this.$store.state.isLoading = true;

  let jsonData = JSON.stringify(payload);
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, jsonData)
      .then((response) => {
        let message = "";
        if (
          typeof response.data !== "undefined" &&
          typeof response.data.message !== "undefined" &&
          response.data.message !== ""
        ) {
          message = response.data.message;
        }
        notification === true ? successNotification(_this, message) : "";
        resolve(response.data.result);
        _this.$store.state.isLoading = false;
      })
      .catch((error) => {
        _this.$store.state.isLoading = false;
        reject(error);
        grepErrorNotification(error, _this);
      });
  });
}
export function RawPOST(payload, url, _this, notification = true) {
  _this.$store.state.isLoading = true;

  let jsonData = JSON.stringify(payload);
  return new Promise((resolve, reject) => {
    axiosInstance
      .post(url, jsonData)
      .then((response) => {
        let message = "";
        if (
          typeof response.data !== "undefined" &&
          typeof response.data.message !== "undefined" &&
          response.data.message !== ""
        ) {
          message = response.data.message;
        }
        notification === true ? successNotification(_this, message) : "";
        resolve(response.data);
        _this.$store.state.isLoading = false;
      })
      .catch((error) => {
        _this.$store.state.isLoading = false;
        reject(error);
        grepErrorNotification(error, _this);
      });
  });
}

function isJson(str) {
  let strr = null;
  try {
    strr = JSON.parse(str);
  } catch (e) {
    return null;
  }
  return strr;
}

export function FILE(payload, url, _this, notification = true) {
  _this.$store.state.isLoading = true;

  return new Promise((resolve, reject) => {
    axiosFile
      .post(url, payload)
      .then((response) => {
        notification == true
          ? successNotification(_this, _this.$store.state.updatedText)
          : "";
        resolve(response.data.result);
        _this.$store.state.isLoading = false;
      })
      .catch((error) => {
        _this.$store.state.isLoading = false;
        reject(error);
        error.response.data.error != undefined
          ? errorNotification(_this, error.response.data.error)
          : errorNotification(_this, error);
      });
  });
}

export function EDIT(id, url, _this, notification = true) {
  _this.$store.state.isLoading = true;

  return new Promise((resolve, reject) => {
    axiosInstance
      .get(url + id)
      .then((response) => {
        notification == true ? primaryNotification(_this) : "";
        resolve(response.data.result);
        _this.$store.state.isLoading = false;
      })
      .catch((error) => {
        _this.$store.state.isLoading = false;
        reject(error);
        error.response.data.error != null
          ? errorNotification(_this, error.response.data.error)
          : errorNotification(_this, error);
      });
  });
}

export function DELETE(id, url, _this, notification = true) {
  if (confirm("Вы уверены что хотите удалить?")) {
    _this.$store.state.isLoading = true;
    return new Promise((resolve, reject) => {
      axiosInstance
        .delete(url + id)
        .then((response) => {
          notification == true
            ? successNotification(_this, "Успешно удалено!")
            : "";
          resolve(response.data.success);
          _this.$store.state.isLoading = false;
        })
        .catch((error) => {
          _this.$store.state.isLoading = false;
          handleAuthError(_this);
          reject(error);
          grepErrorNotification(error, _this);
        });
    });
  }
}

function refreshApiToken() {
  apiToken = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).token
    : null;

  if (apiToken) {
    initHeaders.Authorization = "Bearer " + apiToken;
  }
}

axiosInstance.interceptors.request.use(
  (config) => {
    refreshApiToken();
    if (apiToken) config.headers.Authorization = "Bearer " + apiToken;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosFile.interceptors.response.use(
  (config) => {
    refreshApiToken();
    if (apiToken) config.headers.Authorization = "Bearer " + apiToken;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function primaryNotification(_this, message) {
  _this.$notify({
    group: "foo",
    title: "Успешно",
    text: message,
  });
}

function successNotification(_this, message) {
  _this.$notify({
    group: "foo",
    type: "success",
    title: "Успешно",
    text: message,
  });
}

export function errorNotification(_this, error) {
  _this.$notify({
    group: "foo",
    type: "error",
    duration: 10000,
    title: "Ошибка",
    text: error,
  });
}
